var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGettingStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76969 5.24462L7.55871 1.61242C7.74197 1.24032 8.27251 1.24032 8.45577 1.61242L10.2448 5.24462L14.2521 5.82368C14.6625 5.88299 14.8265 6.38729 14.5296 6.67668L11.6312 9.50074L12.3154 13.4912C12.3854 13.8999 11.9564 14.2113 11.5896 14.0181L8.59751 12.4421C8.64297 12.1905 8.66671 11.9313 8.66671 11.6667C8.66671 9.27341 6.72664 7.33334 4.33337 7.33334C3.69847 7.33334 3.09547 7.46988 2.55211 7.71521L1.4852 6.67688C1.18795 6.38757 1.35189 5.88301 1.76241 5.82368L5.76969 5.24462Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 11.6667C7.99996 13.6917 6.35834 15.3333 4.33329 15.3333C2.30825 15.3333 0.666626 13.6917 0.666626 11.6667C0.666626 9.6416 2.30825 8 4.33329 8C6.35834 8 7.99996 9.6416 7.99996 11.6667ZM2.33329 11.3333C2.1492 11.3333 1.99996 11.4826 1.99996 11.6667C1.99996 11.8507 2.1492 12 2.33329 12H5.52855L4.43093 13.0976C4.30075 13.2278 4.30075 13.4389 4.43093 13.5691C4.5611 13.6992 4.77215 13.6992 4.90233 13.5691L6.56899 11.9024C6.69916 11.7722 6.69916 11.5611 6.56899 11.4309L4.90233 9.76427C4.77215 9.63413 4.5611 9.63413 4.43093 9.76427C4.30075 9.89447 4.30075 10.1055 4.43093 10.2357L5.52855 11.3333H2.33329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingStarted);
export default __webpack_public_path__ + "static/media/getting_started.7dcbcfd36a12f65a7819fc509c0ef457.svg";
export { ForwardRef as ReactComponent };